import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { showSnackbar } from '../../../../../../../actions/runtime';
import {
  clearInsuranceProfile,
  insuranceProfileError,
} from '../../../../../../../actions/insuranceProfile';
import { apiDeleteDispatchableWithoutSource } from '../../../../../../../core/dapi';
import { getInsuranceProfileByIdUrl } from '../../../../../../../core/dapi/insuranceProfile';
import { noOp } from '../../../../../../../actions';
import useSelectInsuranceProfile from '../../../../../hooks/useSelectInsuranceProfile';
import { analyticsTrackEvent } from '../../../../../../../core/analytics';
import { PROFILES_TOUCH_REMOVE_INSURANCE } from '../../../../../../../core/analytics/events';
import { unsetCookie } from '../../../../../../../core/util/cookies';
import { CookieNames } from '../../../../../../../config/index';

export default (userProfileId: any) => {
  const dispatch = useDispatch();
  const insuranceProfile = useSelectInsuranceProfile(userProfileId);

  return useCallback(
    (event) => {
      event.stopPropagation();
      if (!insuranceProfile) return;

      const trackingProperties = {};
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'userProfileId' does not exist on type '{... Remove this comment to see the full error message
      trackingProperties.userProfileId = userProfileId;
      analyticsTrackEvent(PROFILES_TOUCH_REMOVE_INSURANCE, trackingProperties);
      unsetCookie(CookieNames.INSURANCE_TUTORIAL);

      dispatch(showSnackbar('Removing your insurance...'));
      dispatch(clearInsuranceProfile(insuranceProfile.insurance_profile_id));
      dispatch(
        apiDeleteDispatchableWithoutSource(
          getInsuranceProfileByIdUrl(insuranceProfile.insurance_profile_id),
          noOp,
          insuranceProfileError
        )
      );
    },
    [dispatch, insuranceProfile, userProfileId]
  );
};
